import { render, staticRenderFns } from "./lead-center-charts-contacts.component.vue?vue&type=template&id=3ad2cd7b&scoped=true&"
import script from "./lead-center-charts-contacts.component.vue?vue&type=script&lang=js&"
export * from "./lead-center-charts-contacts.component.vue?vue&type=script&lang=js&"
import style0 from "./lead-center-charts-contacts.component.vue?vue&type=style&index=0&id=3ad2cd7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad2cd7b",
  null
  
)

export default component.exports